/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Custom_AdoptInputs */



/**
* | output |
* | --- |
* | "Moved to its own bot" |
*
* @param {Activity_Custom_AdoptInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_custom_adopt = /** @type {((inputs?: Activity_Custom_AdoptInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Custom_AdoptInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сервер переведён на собственного бота")
	return /** @type {LocalizedString} */ ("Moved to its own bot")
});